import React from 'react';
import type { Block } from '../../types';
import ActionBlock from '../Blocks/ActionBlock';
import ChartBlock from '../Blocks/ChartBlock';
import MarkdownBlock from '../Blocks/MarkdownBlock';
import MetricBlock from '../Blocks/MetricBlock';
import TableBlock from '../Blocks/TableBlock';
import TextBlock from '../Blocks/TextBlock';
import ErrorBoundary from '../ErrorBoundary';

interface RenderBlockProps {
  block: Block;
  chartId?: string;
  blockId: string;
}

const RenderBlock: React.FC<RenderBlockProps> = ({ block, chartId, blockId }) => {
  const renderBlockContent = () => {
    switch (block.type) {
      case 'markdown':
        return <MarkdownBlock block={block} blockId={blockId} />;
      case 'chart':
        return <ChartBlock block={block} chartId={chartId} />;
      case 'table':
        return <TableBlock block={block} />;
      case 'text':
        return <TextBlock block={block} blockId={blockId} />;
      case 'metric':
        return <MetricBlock block={block} />;
      case 'actions':
        return <ActionBlock block={block} />;
      default:
        return null;
    }
  };

  return <ErrorBoundary>{renderBlockContent()}</ErrorBoundary>;
};

export default RenderBlock;
